import { postApi } from "./api";

export const AddNDRRemarks = async (NDRRemarks) => {
  try {
    const response = await postApi(
      "/INDR/AddNDRRemarks", NDRRemarks
    );
    return response;

  } catch (error) {
    console(error);
    throw error.response?.data || error.message;
  }
};